import * as React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row, Table, Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Container } from 'reactstrap';
// tslint:disable-next-line:no-unused-variable
import { ICrudGetAllAction, TextFormat, getSortState, IPaginationBaseState, getPaginationItemsNumber, JhiPagination } from 'react-jhipster';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntities } from './book-subscription.reducer';
import { IBookSubscription } from 'app/shared/model/book-subscription.model';
// tslint:disable-next-line:no-unused-variable
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import { getUsers } from 'app/modules/administration/user-management/user-management.reducer';
import { getEntities as getBooks } from 'app/entities/book/book.reducer';

export interface IBookSubscriptionProps extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {}

export interface IBookSubscriptionState extends IPaginationBaseState {
  index: number;
  userId: number;
  bookId: number;
}

export class BookSubscription extends React.Component<IBookSubscriptionProps, IBookSubscriptionState> {
  constructor(props) {
    super(props);
    this.state = {
      ...getSortState(this.props.location, ITEMS_PER_PAGE),
      index: 0,
      userId: -1,
      bookId: -1
    };
  }

  componentDidMount() {
    this.getEntities();
    this.props.getUsers(0, 2500, 'email');
    this.props.getBooks(0, 2000, 'name');
  }

  sort = prop => () => {
    this.setState(
      {
        order: this.state.order === 'asc' ? 'desc' : 'asc',
        sort: prop
      },
      () => this.sortEntities()
    );
  };

  sortEntities() {
    this.getEntities();
    this.props.history.push(`${this.props.location.pathname}?page=${this.state.activePage}&sort=${this.state.sort},${this.state.order}`);
  }

  handlePagination = activePage => this.setState({ activePage }, () => this.sortEntities());

  getEntities = () => {
    const { activePage, itemsPerPage, sort, order, userId, bookId } = this.state;
    this.props.getEntities(activePage - 1, itemsPerPage, `${sort},${order}`, userId, bookId);
  };

  filterEntitities = () => {
    // alert('filterEntitities Method Called');
    const { activePage, itemsPerPage, sort, order, userId, bookId } = this.state;
    this.props.getEntities(activePage - 1, itemsPerPage, `${sort},${order}`, userId, bookId);
  };

  searchByEmailUpdate = element => {
    const selectedValue = element.target.value;
    if (selectedValue === -1) {
      this.setState({
        userId: -1
      });
    } else {
      this.setState({
        userId: selectedValue
      });
    }
  };

  searchByBookUpdate = element => {
    const selectedValue = element.target.value;
    if (selectedValue === -1) {
      this.setState({
        bookId: -1
      });
    } else {
      this.setState({
        bookId: selectedValue
      });
    }
  };

  render() {
    const { bookSubscriptionList, match, totalItems, users, books } = this.props;
    const { userId } = this.state;
    const { bookId } = this.state;
    const UserDropDown = () => (
      <div>
        <Input
          id="book-subscription-search-by-email"
          type="select"
          className="form-control-book-subscription-search-by-email"
          onChange={this.searchByEmailUpdate}
        >
          <option value="-1" key="allusers@gmail.com">
            All Users
          </option>
          {users
            ? users.map(
                otherEntity =>
                  otherEntity.id === parseInt(userId.toString(), 10) ? (
                    <option value={otherEntity.id} key={otherEntity.email} selected>
                      {otherEntity.email}
                    </option>
                  ) : (
                    <option value={otherEntity.id} key={otherEntity.email}>
                      {otherEntity.email}
                    </option>
                  )
              )
            : null}
        </Input>
        {/* <Input id="book-subscription-search-by-email" type="hidden" name="searchBy.id" value={this.state.userId} /> */}
      </div>
    );

    const BookDropDown = () => (
      <div>
        <Input
          id="book-subscription-search-by-book"
          type="select"
          className="form-control-book-subscription-search-by-book"
          onChange={this.searchByBookUpdate}
        >
          <option value="-1" key="all-books">
            All Books
          </option>
          {books
            ? books.map(
                otherEntity =>
                  otherEntity.id === parseInt(bookId.toString(), 10) ? (
                    <option value={otherEntity.id} key={otherEntity.name} selected>
                      {otherEntity.name}
                    </option>
                  ) : (
                    <option value={otherEntity.id} key={otherEntity.name}>
                      {otherEntity.name}
                    </option>
                  )
              )
            : null}
        </Input>
        {/* <Input id="book-subscription-search-by-email" type="hidden" name="searchBy.id" value={this.state.userId} /> */}
      </div>
    );

    return (
      <div>
        <h2 id="book-subscription-heading">
          Book Subscriptions
          <Row className="search-by-email-row">
            <Col>
              <UserDropDown />
            </Col>
            <Col>
              <BookDropDown />
            </Col>
            <Col>
              <Button className="searchByEmailButton" onClick={this.filterEntitities}>
                Search
              </Button>
            </Col>
          </Row>
          <Link to={`${match.url}/new`} className="btn btn-primary float-right jh-create-entity" id="jh-create-entity">
            <FontAwesomeIcon icon="plus" />&nbsp; Create new Book Subscription
          </Link>
        </h2>
        <div className="table-responsive">
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={this.sort('id')}>
                  ID <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={this.sort('isActive')}>
                  Is Active <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={this.sort('subscriptionStartDate')}>
                  Subscription Start Date <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={this.sort('subscriptionEndDate')}>
                  Subscription End Date <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={this.sort('createdDate')}>
                  Created Date <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={this.sort('lastModifiedDate')}>
                  Last Modified Date <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  Book <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  Created By <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  Last Modified By <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={this.sort('user')}>
                  User <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {bookSubscriptionList.map((bookSubscription, i) => (
                <tr key={`entity-${i}`}>
                  <td>
                    <Button tag={Link} to={`${match.url}/${bookSubscription.id}`} color="link" size="sm">
                      {bookSubscription.id}
                    </Button>
                  </td>
                  <td>{bookSubscription.isActive ? 'true' : 'false'}</td>
                  <td>
                    <TextFormat type="date" value={bookSubscription.subscriptionStartDate} format={APP_DATE_FORMAT} />
                  </td>
                  <td>
                    <TextFormat type="date" value={bookSubscription.subscriptionEndDate} format={APP_DATE_FORMAT} />
                  </td>
                  <td>
                    <TextFormat type="date" value={bookSubscription.createdDate} format={APP_DATE_FORMAT} />
                  </td>
                  <td>
                    <TextFormat type="date" value={bookSubscription.lastModifiedDate} format={APP_DATE_FORMAT} />
                  </td>
                  <td>{bookSubscription.book ? <Link to={`book/${bookSubscription.book.id}`}>{bookSubscription.book.name}</Link> : ''}</td>
                  <td>{bookSubscription.createdBy ? bookSubscription.createdBy.login : ''}</td>
                  <td>{bookSubscription.lastModifiedBy ? bookSubscription.lastModifiedBy.login : ''}</td>
                  <td>{bookSubscription.user ? bookSubscription.user.email : ''}</td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${bookSubscription.id}`} color="info" size="sm">
                        <FontAwesomeIcon icon="eye" /> <span className="d-none d-md-inline">View</span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${bookSubscription.id}/edit`} color="primary" size="sm">
                        <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${bookSubscription.id}/delete`} color="danger" size="sm">
                        <FontAwesomeIcon icon="trash" /> <span className="d-none d-md-inline">Delete</span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <Row className="justify-content-center">
          <JhiPagination
            items={getPaginationItemsNumber(totalItems, this.state.itemsPerPage)}
            activePage={this.state.activePage}
            onSelect={this.handlePagination}
            maxButtons={5}
          />
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  bookSubscriptionList: storeState.bookSubscription.entities,
  totalItems: storeState.bookSubscription.totalItems,
  users: storeState.userManagement.users,
  books: storeState.book.entities
});

const mapDispatchToProps = {
  getEntities,
  getUsers,
  getBooks
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(BookSubscription);
